export const logIn_en = {
  'welcome_header' : 'Join Walking Talking today!',
  'welcome_message' : 'A platform that connects you with others for walks, sharing knowledge, experiences and networking - with support for effective walk meetings',
  'join' : 'Join now',
  'create_account' : 'Create account',
  'welcome' : 'Welcome!',
  'create_account_info' : 'Before you start we need some information from you.',
  'firstname' : 'Firstname',
  'lastname' : 'Lastname',
  'next_step' : 'Next step',
  'create_account_GDPR' : "By creating an account you agree to Walking Talking's ",
  'user_agreement' : 'Terms of use',
  'have_account' : 'Have an account?',
  'have_no_account' : 'Do you not have an account?',
  'register_account' : 'Register account',
  'create_account_error_all' : 'Please fill in all fields to continue',
  'create_account_error_email' : 'The e-mail address is already in use. Use another address or',
  'upload_profile_picture' : 'Upload a profile picture',
  'almost_ready' : 'You are almost ready to start walking!',
  'image_info_header' : 'Profile picture',
  'image_info_message' : 'Upload a profile picture to create and book walks.',
  'tip' : 'Tip!',
  'image_info_tips' : 'Users with a profile picture get more walks booked, upload one now!',

  'log_in_info' : 'Log in to create or book walks.',
  'log_in_error_incorrect' : 'Please check your information. You have to enter a valid email and password to continue.',
  'log_in_error_email' : 'Could not find the email - Try again. Did you forget your email address you used, contact Walking Talking on kontakt@walkingtalking.com',
  'log_in_error_password' : 'It looks like you typed the wrong password. Try again or create a new one.',
  'forgotten_password' : 'Forgot your password?',

  'send_new_password' : 'Send email about changing password',
  'new_password_confirmation_part1' : 'Sent email to',
  'new_password_confirmation_part2' : 'Follow the instructions in the email and come back to this page.',

  'verify_account' : 'Verify account',
  'verify_account_header' : 'To continue to create and book walks you need to verify your account.',
  'verify_account_step1' : 'Click the link you got in the email we sent you.',
  'verify_account_step2' : 'Then click on the button below',
  'verified_confirmation' : 'I have verified my email',
  'verified_help' : 'If you could not find the email, you can send a new one below.',
  'send_new_verify' : 'Send a new verification email',

  'new_verified_header' : 'Sent verification email to:',
  'verified_followed' : 'When you have followed the instructions in the email - press Done below',
  'verified_issues_help' : 'If it is the wrong email-address, or if the email has not arrived - Contact Walking Talking on kontakt@walkingtalking.com',

  'need_email_reset' : 'We need your email. Please enter it above.',

  'login_error_valid_email' : 'Please enter a valid email',
  'login_error_correct_email' : 'Please enter a correct email and password',
  'needed_to_create' : 'To create an account you will have to fill out every field: profile picture, ',
  'needed_fields' : 'first- and lastname, email and password'
}